import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { paramCase } from 'change-case';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { BlockOutlined, TaskAltOutlined } from '@material-ui/icons';
import { useSnackbar } from 'notistack'
// material
import { useTheme } from '@material-ui/core/styles';
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText,  } from '@material-ui/core';
import  UserRoleEdit from 'src/components/_dashboard/user/list/UserRoleEdit.js';

// routes
import { PATH_DASHBOARD } from '../../../../routes/paths';
import axios from 'axios';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import ConfirmationPopup from '../../official-request/ConfirmationPopup';

// ----------------------------------------------------------------------

export default function UserRoleView({ userId,roleId,status,roleName,userType,isClientUserRoles }) {
  const ref = useRef(null);
  const theme = useTheme()
  const [isOpen, setIsOpen] = useState(false);
  const [openDeletePop, setOpenDeletePop] = useState(false);
  const { enqueueSnackbar } = useSnackbar()
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem('user'))
  const explodedPermissions =userData?.exploded_permissions

  const changeStatus = async (roleId, roleStatus) => {
    try {
      let id = roleId;
      let status = roleStatus;
      let response = await axios.post(`${REST_API_END_POINT}settings/delete-user-role`,
      {userRoleId:id,status:status,userId:userId});
      if (response.data.status === 1 || response.data.status === 3 || response.data.status === 5) {
        enqueueSnackbar(response.data.message, { variant: 'success' });
        if(isClientUserRoles){
          navigate(PATH_DASHBOARD.client.userRoles, { state: { data: id } });
        }else{
          navigate(PATH_DASHBOARD.adminAccount.userRole, { state: { data: id } });
        }
      }
      else if (response.data.status === 0 || response.data.status === 4 || response.data.status === 6 || response.data.status === 500) {
        enqueueSnackbar(response.data.message, { variant: 'error' });
         if(isClientUserRoles){
          navigate(PATH_DASHBOARD.client.userRoles, { state: { data: id } });
        }else{
        navigate(PATH_DASHBOARD.adminAccount.userRole, { state: { data: id } });
        }
      }
      else {
        console.log("Error.........!");
        enqueueSnackbar("Error.........!", { variant: 'error' });
         if(isClientUserRoles){
          navigate(PATH_DASHBOARD.client.userRoles, { state: { data: id } });
        }else{
        navigate(PATH_DASHBOARD.adminAccount.userRole);
        }
      }
    }
    catch (error) {
      console.log("Delete error : ", error);
    }
  }

  const handleMenuItemClick = async (id, newStatus) => {
    setIsOpen(false);
    setOpenDeletePop(false);
    await changeStatus(id, newStatus);
     if(isClientUserRoles){
          navigate(PATH_DASHBOARD.client.userRoles, { state: { data: id } });
        }else{
    navigate(PATH_DASHBOARD.adminAccount.userRole);
        }
  }

  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >

        <MenuItem
          // disabled={explodedPermissions?.some(permission => ['Edit User Roles'].includes(permission)) ? false : true}
          disabled={userData?.user_type === 3 ? false : isClientUserRoles? !explodedPermissions?.some(permission => ['Update Client User Role'].includes(permission)) : !explodedPermissions?.some(permission => ['Edit User Roles'].includes(permission))}
          component={RouterLink}
          to={`${isClientUserRoles ? `${PATH_DASHBOARD.client.userRoleEdit}/${roleId}` :`${PATH_DASHBOARD.adminAccount.userRoleEdit}/${roleId}`}`}
        >
          <ListItemIcon>
            <Icon icon={editFill} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem>

        {status === 1 ? (
          <MenuItem
          // disabled={explodedPermissions?.some(permission => ['Activate/Deactivate User Roles'].includes(permission)) ? false : true}
          disabled={userData?.user_type === 3 ? false :isClientUserRoles ? !explodedPermissions?.some(permission => ['Activate/Deactivate Client User Role'].includes(permission)) : !explodedPermissions?.some(permission => ['Activate/Deactivate User Roles'].includes(permission))}
          onClick={() => handleMenuItemClick(roleId, 0)}>
            <ListItemIcon>
              <BlockOutlined sx={{ width: 25, height: 25 }} />
            </ListItemIcon>
            <ListItemText primary="Deactivate" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        ) : (
          <MenuItem
          // disabled={explodedPermissions?.some(permission => ['Activate/Deactivate User Roles'].includes(permission)) ? false : true}
          disabled={userData?.user_type === 3 ? false : isClientUserRoles ? !explodedPermissions?.some(permission => ['Activate/Deactivate Client User Role'].includes(permission)) : !explodedPermissions?.some(permission => ['Activate/Deactivate User Roles'].includes(permission))}
          onClick={() => handleMenuItemClick(roleId, 1)}>
            <ListItemIcon>
              <TaskAltOutlined sx={{ width: 25, height: 25 }} />
            </ListItemIcon>
            <ListItemText primary="Activate" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}

        <MenuItem
        disabled={(isClientUserRoles ? explodedPermissions?.some(permission => ['Delete Client User Role'].includes(permission)) :explodedPermissions?.some(permission => ['Delete User Roles'].includes(permission))) ? false : true}
        // disabled={userData?.user_type === 3 ? false : !explodedPermissions?.some(permission => ['Delete User Roles'].includes(permission))}
        onClick={()=>{setOpenDeletePop(true),setIsOpen(false)}}>
          <ListItemIcon>
            <Icon icon={trash2Outline} width={24} height={24} />
          </ListItemIcon>
          <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem> 
      </Menu>
    {/* Confirmation for deleting user role  */}
    <ConfirmationPopup
      open={openDeletePop}
      handleClose={()=>{setOpenDeletePop(false)}}
      message={`You want to delete ${roleName} ! `}
      handleClick={()=>{handleMenuItemClick(roleId, 2)}}
    />
    </>
  );
}
